import React from "react";
import * as cls from "./oralClasses.module.scss";
import { useSelector } from "react-redux";
import { TableLoader, TableModel } from "../../components/tableLoader";

function OralClasses() {
  const { contractId } = useSelector((state) => state.contract);
  const { access_token } = useSelector((state) => state.token);
  const loader = {
    title: "Устные виды занятий",
    icon: "survey",
    request: {
      method: "post",
      path: "/student/portfolio/oral_classes",
      data: {
        access_token,
        study_contract_id: contractId,
      },
    },
    parser: createModel,
  };
  function createModel(response) {
    const table = new TableModel(response);
    table.columns = table.columns.filter(
      (el) => el.field !== "study_session_id"
    );
    table.columns.forEach((element) => {
      if (element.field === "url") {
        element.type = "html";
      }
      if (element.field === "date") {
        element.type = "date";
      }
      if (element.field === "review") {
        element.type = "link";
      }
    });
    table.rows = table.rows.map((row) => ({
      ...row,
      review: {
        name: "Review",
        href: row.review,
      },
    }));
    return table;
  }
  return <TableLoader {...loader} />;
}

export default OralClasses;
